import React from 'react';
import { StyledLink } from './Link.styled';

const Link = ({ children, ...props }) => {
  return (
    <StyledLink {...props}>
      {children}
    </StyledLink>
  );
};

export default Link;